export default __webpack_public_path__ + "static/media/Group4.67b468f7.png";